import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from 'ngx-mask';
import { LocalBootstrapModule } from './local-bootstrap';

import { CoinDepoDropdownComponent } from './components/dropdown/dropdown.component';
import { LoaderComponent } from './components/loader/loader.component';
import { SelectComponent } from './components/select/select.component';
import { ExchangeRateComponent } from './components/exchange-rate/exchange-rate.component';
import { FormsModule } from '@angular/forms';
import { MultiSelectDropdownComponent } from './components/multi-select-dropdown/multi-select-dropdown.component';
import { TranslateModule } from '@ngx-translate/core';
import { StripedAccountStatusComponent } from './components/striped-account-status/striped-account-status.component';
import { CoinProgressStylePipe } from './pipes/coin-progress-style.pipe';
import { AppendZeroIfZeroPipe } from './pipes/append-zero-if-zero.pipe';
import { MomentFormatPipe } from './pipes/moment-format.pipe';
import { CoinPrecisionPipe } from './pipes/coin-precision.pipe';
import { AbsPipe } from './pipes/abs.pipe';
import { SignRequiredPipe } from './pipes/sign-required.pipe';
import { TransactionsTitleWithPaginationComponent } from './components/transactions-title-with-pagination/transactions-title-with-pagination.component';


@NgModule({
  declarations: [
    CoinDepoDropdownComponent,
    LoaderComponent,
    SelectComponent,
    ExchangeRateComponent,
    MultiSelectDropdownComponent,
    StripedAccountStatusComponent,
    TransactionsTitleWithPaginationComponent,
    CoinProgressStylePipe,
    AppendZeroIfZeroPipe,
    MomentFormatPipe,
    CoinPrecisionPipe,
    AbsPipe,
    SignRequiredPipe
  ],
  providers: [
    provideNgxMask(),
  ],
  exports: [
    NgScrollbarModule,
    CoinDepoDropdownComponent,
    LocalBootstrapModule,
    NgxMaskDirective,
    NgxMaskPipe,
    LoaderComponent,
    SelectComponent,
    ExchangeRateComponent,
    MultiSelectDropdownComponent,
    StripedAccountStatusComponent,
    TransactionsTitleWithPaginationComponent,
    CoinProgressStylePipe,
    AppendZeroIfZeroPipe,
    MomentFormatPipe,
    CoinPrecisionPipe,
    AbsPipe,
    SignRequiredPipe
  ],
  imports: [
    CommonModule,
    NgScrollbarModule,
    LocalBootstrapModule,
    NgxMaskDirective,
    NgxMaskPipe,
    FormsModule,
    TranslateModule
  ]
})
export class SharedModule { }
